import {Vue, Component, Prop} from 'vue-property-decorator';

@Component({
    name: 'process-item',
})
export default class ProcessItem extends Vue {

    @Prop({ type: Object, required: true }) item!: task.webpartProcessResponse

    get prevTaskName() {
        return this.item.prevTask ? this.item.prevTask.processTaskName : null;
    }

    get waitTaskName() {
        return this.item.waitTask ? this.item.waitTask.processTaskName : null;
    }

    get nextTaskName() {
        return this.item.nextTask ? this.item.nextTask.processTaskName : null;
    }
}